import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';

(window as any).CESIUM_BASE_URL = window.location.href + '/Cesium'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(<App />);
